import { createSelector } from "reselect";

import { Customer, AppState } from "./model";

export const routeIdSelector = (state: AppState): string => state.router.params!.customerId!; // eslint-disable-line @typescript-eslint/no-non-null-assertion

export type SelectorState = AppState;

export const customersSelector = (state: AppState) => state.customers;

/**
 * @deprecated replaced by `useCustomerDetailsModel` hook
 */
export const customerSelector = createSelector(
    customersSelector,
    routeIdSelector,
    (customers: Customer[], id: string) => {
        return customers.filter(c => c.id === id)[0] || {} as Customer;
    }
);

export const basePathSelector = (state: AppState) =>
    state.router.pathname!.substring( // eslint-disable-line @typescript-eslint/no-non-null-assertion
        0,
        state.router.pathname!.indexOf("customers") + "customers".length // eslint-disable-line @typescript-eslint/no-non-null-assertion
    );
